import React from 'react';

import './index.less';

import checkoutLiveChatIcon from 'ck-core-client/graphics/checkout/checkout-live-chat-icon.svg';
import checkoutEmailIcon from 'ck-core-client/graphics/checkout/checkout-email-icon.svg';

let supportEmail = 'support@codekingdoms.com';

 if (CK.config.name === 'ck-coolmath') supportEmail = 'help@coolmathcoding.com';

export const HereToHelp: React.SFC<{ openIntercom: () => void }> = ({ openIntercom }) => (
	<div className="HereToHelp">
		<div>Any questions? Get in touch!</div>
		{/* <a href="#" onClick={openIntercom} className="HereToHelp__link">
			<div className="HereToHelp__option">
				<img className="HereToHelp__image" src={checkoutLiveChatIcon} />
				Chat to us
			</div>
		</a> */}

		<div className="HereToHelp__option">
			<a href={`mailto:${supportEmail}`} className="HereToHelp__link">
				<img className="HereToHelp__image" src={checkoutEmailIcon} />
				{supportEmail}
			</a>
		</div>
	</div>
);
